import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
const Form = () => {

  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    dob: "",
    age: "",
    gender: "",
    photo: null,
    // ✅ ADD THIS
    address: "",
    branch: "",
    physicalProblem: "no",
    physicalProblemDescription: "",
    planDuration: "",
    preferredTimeSlot: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  // ✅ TERMS STATES (ADDED – NO STYLE CHANGE)
  const [showTerms] = useState(true);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState("");

  // API
  const API_URL = process.env.REACT_APP_API_URL || "http://192.168.1.33:5000";

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "radio" ? (checked ? value : prevData[name]) : value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      photo: e.target.files[0] || null,
    }));
  };

  // ✅ Auto-calculate age
  useEffect(() => {
    if (!formData.dob) return;

    const birthDate = new Date(formData.dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    setFormData((prev) => ({
      ...prev,
      age: age.toString(),
    }));
  }, [formData.dob]);

  // ❌ REMOVED DOM MANIPULATION (NOT NEEDED, STYLE ALREADY HANDLED IN JSX)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    // ✅ TERMS VALIDATION (ADDED)
    if (showTerms && !termsAccepted) {
      setTermsError("Please accept the Terms & Conditions to proceed.");
      return;
    }

    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    setLoading(true);

    const data = new FormData();
    for (const key in formData) {
      if (key === "photo" && formData.photo) {
        data.append(key, formData.photo);
      } else {
        data.append(key, formData[key]);
      }
    }

    try {
      const response = await fetch(`${API_URL}/api/requests/submit`, {
        method: "POST",
        body: data,
      });

      console.log("Response:", response);

      if (!response.ok) {
        let errorMessage = "Something went wrong!";
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch {}
        throw new Error(errorMessage);
      }

      const result = await response.json();
     Swal.fire({
  icon: "success",
  title: "Request Submitted!",
  text: "Thank you! We have received your admission request. Our team will contact you shortly for the next steps.",
});

      // ✅ RESET FORM (FUNCTIONALITY ONLY)
      setFormData({
        fullName: "",
        mobileNumber: "",
        dob: "",
        age: "",
        gender: "",
        photo: null,
        address: "",
        branch: "",
        physicalProblem: "no",
        physicalProblemDescription: "",
        planDuration: "",
        preferredTimeSlot: "",
      });

      setTermsAccepted(false);
      setTermsError("");
      form.classList.remove("was-validated");
    } catch (err) {
      console.error("Submission error:", err);
      setError(
        err.message ||
          "Failed to submit registration. Is the backend server running?",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <section className="academy-wrapper container" id="form-section">
        <h2 className="title">Join the Academy</h2>
        <p className="subtitle px-3 px-md-0">
          Ready to start your cricketing journey? Fill out the form below to
          register.
        </p>

        {loading && (
          <div className="alert alert-info">Submitting registration...</div>
        )}
        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && (
          <div className="alert alert-success">{successMessage}</div>
        )}

        <form
          className="academy-form needs-validation"
          noValidate
          onSubmit={handleSubmit}
        >
          {/* Personal Details */}
          <div className="form-section">
            <div className="section-header">
              <span>👤</span> Personal Details
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  placeholder="Enter full name"
                  required
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">
                  Please enter a full name.
                </div>
              </div>

              {/* Mobile Number with +91 */}
              <div className="form-group">
                <label>Mobile Number</label>

                <div className="mobile-input-wrapper">
                  <span className="country-code">+91</span>
                  <input
                    type="tel"
                    name="mobileNumber"
                    placeholder="0000000000"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    required
                    maxLength={10}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  required
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">
                  Please select a date of birth.
                </div>
              </div>

              <div className="form-group">
                <label>Age</label>
                <input
                  type="text"
                  placeholder="Please Fill DOB"
                  disabled
                  name="age"
                  value={formData.age}
                />
              </div>

              <div className="form-group">
                <label>Gender</label>
                <select
                  required
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option>Male</option>
                  <option>Female</option>
                </select>
                <div className="invalid-feedback">Please select a gender.</div>
              </div>

              <div className="form-group">
                <label>Upload Photo</label>
                <input
                  type="file"
                  name="photo"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
              <div className="form-group">
                <label>Address</label>
                <textarea
                  placeholder="Enter full residential address"
                  required
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  rows="4"
                />
                <div className="invalid-feedback">Please enter an address.</div>
              </div>
              <div className="form-group">
                <label>Branch</label>
                <select
                  required
                  name="branch"
                  value={formData.branch}
                  onChange={handleChange}
                >
                  <option value="">Select Branch</option>
                  <option value="Utran">Utran,Surat</option>
                  <option value="Parvat">Parvat Patiya,Surat</option>
                </select>
                <div className="invalid-feedback">Please select a branch.</div>
              </div>
            </div>
          </div>

          {/* Medical Information */}
          <div className="form-section">
            <div className="section-header">🩺 Medical Information</div>
            <div className="form-grid">
              <div className="form-group">
                <label>Physical Problem?</label>
                <div className="radio-options">
                  <label>
                    <input
                      type="radio"
                      name="physicalProblem"
                      value="yes"
                      checked={formData.physicalProblem === "yes"}
                      onChange={handleChange}
                    />
                    Yes
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="physicalProblem"
                      value="no"
                      checked={formData.physicalProblem === "no"}
                      onChange={handleChange}
                    />
                    No
                  </label>
                </div>
              </div>
              <div
                className="form-group full-width"
                style={{
                  display:
                    formData.physicalProblem === "yes" ? "block" : "none",
                }}
              >
                <label>Description</label>
                <textarea
                  placeholder="Describe any physical problems or medical conditions"
                  name="physicalProblemDescription"
                  value={formData.physicalProblemDescription}
                  onChange={handleChange}
                  required={formData.physicalProblem === "yes"}
                />
                <div className="invalid-feedback">
                  Please provide a description of the physical problem.
                </div>
              </div>
            </div>
          </div>

          {/* Training Details */}
          <div className="form-section">
            <div className="section-header">🏋️ Training Details</div>
            <div className="form-grid">
              <div className="form-group">
                <label>Plan Duration</label>
                <select
                  required
                  name="planDuration"
                  value={formData.planDuration}
                  onChange={handleChange}
                >
                  <option value="">Select Plan</option>
                  <option value="1 Month">1 Month – ₹2000</option>
                  <option value="2 Months">2 Months – ₹3500</option>
                  <option value="3 Months">3 Months – ₹4500</option>
                  <option value="6 Months">6 Months – ₹8000</option>
                  <option value="12 Months">12 Months – ₹15000</option>
                </select>
                <div className="invalid-feedback">
                  Please select a plan duration.
                </div>
              </div>

              <div className="form-group">
                <label>Preferred Time Slot</label>

                <select
                  required
                  name="preferredTimeSlot"
                  value={formData.preferredTimeSlot}
                  onChange={handleChange}
                >
                  <option value="">Select Time Slot</option>

                  <optgroup label="Morning">
                    <option value="7:00 AM - 8:30 AM">7:00 AM - 8:30 AM</option>
                  </optgroup>

                  <optgroup label="Evening">
                    <option value="5:00 PM - 6:30 PM">5:00 PM - 6:30 PM</option>
                    <option value="6:30 PM - 8:00 PM">6:30 PM - 8:00 PM</option>
                    <option value="8:00 PM - 9:30 PM">8:00 PM - 9:30 PM</option>
                  </optgroup>
                </select>

                <div className="invalid-feedback">
                  Please select a preferred time slot.
                </div>
              </div>
            </div>
          </div>
          {/* TERMS BOX */}
          {showTerms && (
            <div className="termsBox"
              style={{
                marginTop: "20px",
                padding: "30px",
                borderRadius: "8px",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
                backgroundColor: "var(--bs-body-bg)",
                borderBottom: "none",
              }}
            >
              <h4>Terms & Conditions</h4>
              <ul>
                <li>Fees once paid are non-refundable and non-transferable.</li>
                <li>
                  All registration details provided must be accurate and
                  complete.
                </li>
                <li>
                  Players must be medically fit; any existing health
                  condition/injury must be disclosed before joining.
                </li>
                <li>
                  The academy is not responsible for any loss, injury, or
                  accident during training/matches; participation is at the
                  player's own risk.
                </li>
                <li>
                  Regular attendance and punctuality are required; missed
                  sessions may not be compensated.
                </li>
                <li>
                  Maintaining discipline, respectful behavior, and following
                  coach instructions is mandatory; misconduct can lead to
                  suspension.
                </li>
                <li>
                  Players must bring their own basic kit (as advised) and take
                  care of personal belongings.
                </li>
                <li>
                  Training schedule, batch timings, and coach assignments may
                  change based on operational requirements.
                </li>
                <li>
                  Photos/videos may be taken during sessions for academy
                  promotion; if you do not consent, please inform us in writing.
                </li>
                <li>
                  Parents/guardians (for minors) are responsible for timely
                  pickup/drop and consent to the player’s participation.
                </li>
              </ul>

              <label style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => {
                    setTermsAccepted(e.target.checked);
                    if (e.target.checked) setTermsError("");
                  }}
                />
                I confirm that the information provided is correct, and I accept
                the Academy Terms & Conditions
              </label>

              {termsError && (
                <div
                  style={{ color: "red", marginTop: "8px", fontSize: "14px" }}
                >
                  {termsError}
                </div>
              )}
            </div>
          )}

          <div className="submit-wrap">
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Registration"}
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default Form;
